import React from 'react';
import PropTypes from 'prop-types';

import { AdTypes } from '../../utils/types';
import useIsMobile from '../hooks/useIsMobile';
import SnackAdUnit from './SnackAds/SnackAdUnit';

import styles from './adWrapper.scss';

const AdWrapper = ({ type, 'data-testid': dataTestId }) => {
    const {
        STICKY,
        RECTANGLE_ONE,
        RECTANGLE_TWO,
        RECTANGLE_THREE,
        SKYSCRAPER_LEFT,
        SKYSCRAPER_RIGHT,
        LEADERBOARD_ONE,
        LEADERBOARD_TWO,
        WIDE_LEADERBOARD_ONE,
        WIDE_LEADERBOARD_TWO,
    } = AdTypes;
    const { isMobileWidth } = useIsMobile();
    const adLabel = 'ADVERTISEMENT';

    const handleOnCloseStickyAd = () => {
        // This function was given to us by Snack Media and shouldn't be altered

        const stickyWrapper = document.getElementById('sn_gg_ad_wrapper');
        const stickyWrapperClose = document.getElementById('sn_gg_close');

        try {
            window.killSlot([sn_gg_tag]);
        } catch (error) {
            console.log('KillSlot Error', error);
        }
        if (typeof stickyWrapper !== 'undefined') {
            stickyWrapper.remove();
        }

        if (typeof stickyWrapperClose !== 'undefined') {
            stickyWrapperClose.remove();
        }
    };

    const renderAd = (adType) => {
        const stickyStyles = isMobileWidth ? styles.snackStickyMobile : styles.snackStickyDesktop;
        const leaderboardStyles = isMobileWidth ? styles.mobileLeaderboard : styles.desktopLeaderboard;
        const rectangleStyles = isMobileWidth ? styles.mobileRectangle : styles.desktopRectangle;
        const wideLeaderboardStyles = isMobileWidth ? styles.mobileWideLeaderboard : styles.desktopWideLeaderboard;

        switch (adType) {
            case STICKY:
                return (
                    <div id="sn_gg_ad_wrapper" className={stickyStyles}>
                        <div id="sn_gg_close" className={styles.snClose} role="button" onClick={handleOnCloseStickyAd}><span>&times;</span></div>
                        <SnackAdUnit unitType={STICKY} />
                    </div>
                );
            case LEADERBOARD_ONE: {
                return (
                    <div className={leaderboardStyles}>
                        <SnackAdUnit unitType={LEADERBOARD_ONE} />
                    </div>
                );
            }
            case LEADERBOARD_TWO: {
                return (
                    <div className={rectangleStyles}>
                        <SnackAdUnit unitType={LEADERBOARD_TWO} />
                    </div>
                );
            }
            case RECTANGLE_ONE: {
                 return (
                     <div className={rectangleStyles}>
                         <SnackAdUnit unitType={RECTANGLE_ONE} />
                     </div>
                );
            }
            case RECTANGLE_TWO: {
                 return (
                     <div className={rectangleStyles}>
                         <SnackAdUnit unitType={RECTANGLE_TWO} />
                     </div>
                );
            }
            case RECTANGLE_THREE: {
                 return (
                     <div className={styles.desktopRectangle}>
                         <SnackAdUnit unitType={RECTANGLE_THREE} />
                     </div>
                );
            }
            case SKYSCRAPER_LEFT: {
                return (
                    <div className={styles.skyscraper}>
                        <SnackAdUnit unitType={SKYSCRAPER_LEFT} />
                    </div>
                );
            }
            case SKYSCRAPER_RIGHT: {
                return (
                    <div className={styles.skyscraper}>
                        <SnackAdUnit unitType={SKYSCRAPER_RIGHT} />
                    </div>
                );
            }
            case WIDE_LEADERBOARD_ONE: {
                return (
                    <div className={wideLeaderboardStyles}>
                        <SnackAdUnit unitType={WIDE_LEADERBOARD_ONE} />
                    </div>
                );
            }
            case WIDE_LEADERBOARD_TWO: {
                return (
                    <div className={wideLeaderboardStyles}>
                        <SnackAdUnit unitType={WIDE_LEADERBOARD_TWO} />
                    </div>
                );
            }
            default:
                return <div />;
        }
    };

    return (
        <div data-testid={dataTestId}>
            <p className={styles.adLabel} data-testid={dataTestId ? `${dataTestId}.label` : undefined}>{adLabel}</p>
            {renderAd(type)}
        </div>
    );
};

export default AdWrapper;

AdWrapper.propTypes = {
    type: PropTypes.string.isRequired,
};
